"use strict";

require("core-js/modules/es.array.flat-map.js");

require("core-js/modules/es.array.unscopables.flat-map.js");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.merge = void 0;

var merge = function merge(items, depth) {
  if (depth === void 0) {
    depth = Infinity;
  }

  return items.flatMap(Object.entries).reduce(function (prev, _a) {
    var _b, _c, _d, _e;

    var _f = __read(_a, 2),
        key = _f[0],
        value = _f[1];

    var prevValue = prev[key];

    if (Array.isArray(value) && Array.isArray(prevValue)) {
      return __assign(__assign({}, prev), (_b = {}, _b[key] = depth > 0 ? Object.entries((0, exports.merge)([prevValue, value], depth - 1)).map(function (_a) {
        var _b = __read(_a, 2),
            key = _b[0],
            value = _b[1];

        return value;
      }) : value, _b));
    }

    if (typeof value === 'object' && typeof prevValue === 'object') {
      return __assign(__assign({}, prev), (_c = {}, _c[key] = depth > 0 ? (0, exports.merge)([prevValue, value], depth - 1) : value, _c));
    }

    if (typeof value === 'function' && typeof prevValue === 'function') {
      return __assign(__assign({}, prev), (_d = {}, _d[key] = depth > 0 ? function () {
        var args = [];

        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }

        var prevResult = prevValue.apply(void 0, __spreadArray([], __read(args), false));
        var result = value.apply(void 0, __spreadArray([], __read(args), false));

        if (Array.isArray(result) && Array.isArray(prevResult)) {
          return Object.entries((0, exports.merge)([prevResult, prevValue], depth - 1)).map(function (_a) {
            var _b = __read(_a, 2),
                key = _b[0],
                value = _b[1];

            return value;
          });
        }

        if (typeof result === 'object' && typeof prevResult === 'object') {
          return __assign(__assign({}, prevResult), result);
        } else {
          return result;
        }
      } : value, _d));
    }

    return __assign(__assign({}, prev), (_e = {}, _e[key] = value, _e));
  }, {});
};

exports.merge = merge;